module.exports = "/_next/static/images/digitalbanking-monotone-ab4a015d0ee7ba2aa71832caf8918ac4.svg";